var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSidebarMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3546,
    cy: 17.3546,
    r: 17.3546,
    fill: "#FD8A24"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6935,
    cy: 20.3214,
    r: 3.9513,
    fill: "#FD8A24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6823 16.3706C30.3455 16.4029 26.8398 19.9285 26.8398 24.273H18.9372C18.9372 16.3508 24.7659 9.78987 32.3689 8.64482C33.7024 10.9385 34.5254 13.5656 34.6823 16.3706ZM13.1487 24.273C13.1487 19.9084 16.6868 16.3704 21.0513 16.3704V8.46777C12.3391 8.46777 5.27334 15.5168 5.24617 24.2226L13.1487 24.273Z",
    fill: "#383ECD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSidebarMini);
export default __webpack_public_path__ + "static/media/logo-sidebar-mini.da776b09ff94548649527a674306ea44.svg";
export { ForwardRef as ReactComponent };